import { render } from "./BarChartEdit.vue?vue&type=template&id=237ec57b"
import script from "./BarChartEdit.vue?vue&type=script&lang=js"
export * from "./BarChartEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mediaproperty/BarChartEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "237ec57b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('237ec57b', __exports__)) {
    api.reload('237ec57b', __exports__)
  }
  
  module.hot.accept("./BarChartEdit.vue?vue&type=template&id=237ec57b", () => {
    api.rerender('237ec57b', render)
  })

}


export default __exports__